import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconNote = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 48 48" fill="none">
    <g opacity="0.5">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 12C6.5 6.75329 10.7533 2.5 16 2.5H32C37.2467 2.5 41.5 6.75329 41.5 12V36C41.5 41.2467 37.2467 45.5 32 45.5H16C10.7533 45.5 6.5 41.2467 6.5 36V12ZM16 5.5C12.4101 5.5 9.5 8.41015 9.5 12V36C9.5 39.5899 12.4101 42.5 16 42.5H32C35.5899 42.5 38.5 39.5899 38.5 36V12C38.5 8.41015 35.5899 5.5 32 5.5H16ZM14.5 14C14.5 13.1716 15.1716 12.5 16 12.5H32C32.8284 12.5 33.5 13.1716 33.5 14C33.5 14.8284 32.8284 15.5 32 15.5H16C15.1716 15.5 14.5 14.8284 14.5 14ZM14.5 24C14.5 23.1716 15.1716 22.5 16 22.5H32C32.8284 22.5 33.5 23.1716 33.5 24C33.5 24.8284 32.8284 25.5 32 25.5H16C15.1716 25.5 14.5 24.8284 14.5 24ZM14.5 34C14.5 33.1716 15.1716 32.5 16 32.5H24C24.8284 32.5 25.5 33.1716 25.5 34C25.5 34.8284 24.8284 35.5 24 35.5H16C15.1716 35.5 14.5 34.8284 14.5 34Z"
        fill="currentColor"
      />
    </g>
  </SvgIcon>
)
